import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFriends } from "state";
import { Box, Divider, Typography, useTheme } from "@mui/material";
import api from 'state/axios';
import Friend from "components/Friend";
import WidgetWrapper from "components/WidgetWrapper";

const FriendListWidget = ({ userId }) => {
  const dispatch = useDispatch();
  const { palette } = useTheme();
  const friends = useSelector((state) => state.user.friends);

  
  const getFriends = async () => {
    const response = await api.get(`/users/${userId}/friends`, {
      skipAuth: true
    });
    dispatch(setFriends({ friends: response.data }));
  };

  useEffect(() => {
    getFriends();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (friends.message) return null;

  return (
    <WidgetWrapper>
      <Typography
        color={palette.neutral.darkest}
        variant="h5"
        fontWeight="600"
        sx={{ mb: 1.5 }}
      >
        Friend List
      </Typography>
      <Box display="flex" flexDirection="column">
        {friends.map((friend, index) => (
          <Fragment key={friend._id}>
            <Friend
              friendId={friend._id}
              name={`${friend.firstName} ${friend.lastName}`}
              subtitle={friend.occupation}
              userPicturePath={friend.picturePath}
            />
            {index < friends.length - 1 && (
              <Divider sx={{ my: 1, opacity: 0.4 }} />
            )}
          </Fragment>
        ))}
        {friends.length === 0 && (
          <Typography color={palette.neutral.deep} fontSize="0.85rem">
            No friends yet
          </Typography>
        )}
      </Box>
    </WidgetWrapper>
  );
};

export default FriendListWidget;
